import { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import SplashScreen from "./SplashScreen";

function DashboardRedirector() {
  const navigate = useNavigate();
  const location: any = useLocation();
  const userContext = useAuth();

  useEffect(() => {
    if (!!userContext?.userType) {
      navigate(`/${userContext.userType}/dashboard/`, {
        state: { from: location?.state?.from },
      });
    }
  }, []);

  return <SplashScreen />;
}

export default DashboardRedirector;
